/**
 * Normalize diacritics for cross-lingual matching.
 * - German: ü→u, ö→o, ä→a, ß→ss before NFD strip (preserves the doubled-s)
 * - Other: NFD + combining mark strip
 * - Always lowercases and trims
 *
 * Used by the query preprocessor AND by the index builder so comparisons run
 * normalized↔normalized.
 */
export function normalizeDiacritics(input: string, lang: 'de' | 'en' | string = 'de'): string {
  if (!input) return '';
  let s = input.toLowerCase();
  if (lang === 'de') {
    s = s
      .replace(/ü/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/ä/g, 'a')
      .replace(/ß/g, 'ss');
  }
  // NFD: split combining marks; then strip them
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}

/**
 * Light-weight token splitter aware of German umlauts.
 * Keeps original umlauts (caller is expected to normalize diacritics separately
 * if cross-form comparison is desired).
 */
export function splitTokens(input: string): string[] {
  return input
    .toLowerCase()
    .replace(/[^\w\säöüß]/g, ' ')
    .split(/\s+/)
    .filter((t) => t.length > 1);
}
